import React from "react"
import PropTypes from "prop-types"
import SocialLinks from "./SocialLinks";
import Score from "./Score";

class FuturePopup extends React.Component {
  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div
        ref={this.props.innerRef}
        id='aspirations-popup'
        className='ignore-click fixed popup full-height full-width top left flex-container align-center-middle secondary-bg grid-x'
      >

        {this.props.survey &&
          <div>
            <Score survey={this.props.survey} />
            <SocialLinks />
          </div>
        }

        {!this.props.survey &&
          <React.Fragment>

            {!this.props.noQuiz &&
              <div className='cell medium-6'>
                <h2 className='mmb text-center lp'>
                  Great, do you want to try the quiz now?
                </h2>


                {/* Link To Quiz, passing Survey id  */}
                <a
                  className='block'
                  href={`/quiz?id=${this.props.id}`}
                >
                  <button className='button expanded'>
                    <h4>
                      Start Quiz
                    </h4>
                  </button>
                </a>

                <button
                  className='button block expanded'
                  onClick={this.props.handleNoQuiz}
                >
                  <h4>
                    No
                  </h4>
                </button>
              </div>
            }

            {this.props.noQuiz &&
              <div className='cell medium-6'>
                <h1 className='text-center mp'>
                  Thanks!
                </h1>

                <SocialLinks />
              </div>
            }

          </React.Fragment>
        }

      </div>
    );
  }
}


export default React.forwardRef((props, ref) => <FuturePopup
  innerRef={ref} {...props}
/>);
